import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { WorkplaceGroupFragment } from '@api/fragments'
import { IWorkplaceGroup } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateWorkplaceGroup: { workplaceGroup: IWorkplaceGroup }
}

const mutation = gql`
  mutation UpdateWorkplaceGroupMutation($input: UpdateWorkplaceGroupInput!) {
    updateWorkplaceGroup(input: $input) {
      workplaceGroup {
        ...WorkplaceGroupFragment
      }
    }
  }
  ${WorkplaceGroupFragment}
`

const mutateHandler = handleFetchResult<IPayload, IWorkplaceGroup>({
  handler: (data) => data.updateWorkplaceGroup.workplaceGroup,
  name: 'Update Employees',
})

type UpdateWorkplaceGroupT = (payload: {
  workplaceGroupId: string
  employeeIds: string[]
}) => Promise<IWorkplaceGroup>

const updateWorkplaceGroupEmployees: UpdateWorkplaceGroupT = async ({
  workplaceGroupId,
  employeeIds,
}) => {
  const input = {
    id: workplaceGroupId,
    employeeIds,
  }

  try {
    const response = await client.gql.mutate({ mutation, variables: { input } })

    return mutateHandler(response)
  } catch (e: any) {
    return e
  }
}

export default updateWorkplaceGroupEmployees
